import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const LandingPage = () => {
    const { t } = useTranslation();

    const sports = [
        { icon: '⚽', name: t('football') },
        { icon: '🎾', name: t('tennis') },
        { icon: '🏀', name: t('basketball') },
        { icon: '🏐', name: t('volleyball') },
        { icon: '🎾', name: t('padel') },
        { icon: '🏉', name: t('rugby') }
    ];

    const features = [
        {
            title: t('feature_whatsapp_title'),
            description: t('feature_whatsapp_desc'),
            icon: '📱'
        },
        {
            title: t('feature_maps_title'),
            description: t('feature_maps_desc'),
            icon: '🚗'
        },
        {
            title: t('feature_waitlist_title'),
            description: t('feature_waitlist_desc'),
            icon: '📋'
        },
        {
            title: t('feature_all_games_title'),
            description: t('feature_all_games_desc'),
            icon: '🔄'
        }
    ];

    return (
        <div className="landing-page">
            <style>{`
                .landing-page {
                    padding-bottom: 40px;
                }
                .hero {
                    text-align: center;
                    padding: 50px 15px;
                    background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);
                    color: white;
                    border-radius: 15px;
                    margin-bottom: 40px;
                    box-shadow: 0 4px 20px rgba(46, 125, 50, 0.2);
                }
                .hero h1 {
                    font-size: 2.2rem;
                    margin-bottom: 15px;
                    color: white;
                    line-height: 1.2;
                }
                .hero p {
                    font-size: 1.1rem;
                    max-width: 550px;
                    margin: 0 auto 25px;
                    opacity: 0.9;
                }
                .hero-btns {
                    display: flex;
                    gap: 12px;
                    justify-content: center;
                }
                .hero-btn-primary {
                    background: white;
                    color: #2e7d32;
                    padding: 10px 25px;
                    border-radius: 25px;
                    font-weight: 700;
                    text-decoration: none;
                    transition: transform 0.2s ease;
                    display: inline-block;
                }
                .hero-btn-secondary {
                    background: rgba(255, 255, 255, 0.1);
                    color: white;
                    padding: 10px 25px;
                    border-radius: 25px;
                    font-weight: 700;
                    text-decoration: none;
                    border: 1px solid rgba(255, 255, 255, 0.3);
                    transition: background 0.2s ease;
                    display: inline-block;
                }
                .hero-btn-primary:hover {
                    transform: scale(1.03);
                }
                .hero-btn-secondary:hover {
                    background: rgba(255, 255, 255, 0.2);
                }
                .section-title {
                    text-align: center;
                    margin-bottom: 25px;
                    font-size: 1.6rem;
                }
                .features-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
                    gap: 20px;
                    margin-bottom: 50px;
                }
                .feature-card {
                    background: white;
                    padding: 20px;
                    border-radius: 12px;
                    text-align: center;
                    box-shadow: 0 2px 10px rgba(0,0,0,0.05);
                }
                .feature-icon {
                    font-size: 2.5rem;
                    margin-bottom: 12px;
                    display: block;
                }
                .feature-card h3 {
                    margin-bottom: 10px;
                    color: #2e7d32;
                    font-size: 1.1rem;
                }
                .feature-card p {
                    font-size: 0.9rem;
                    line-height: 1.4;
                }
                .sports-strip {
                    display: flex;
                    justify-content: center;
                    gap: 25px;
                    flex-wrap: wrap;
                    margin-bottom: 50px;
                    padding: 15px;
                    border-radius: 12px;
                    background: rgba(0,0,0,0.015);
                }
                .sport-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    gap: 5px;
                    font-weight: 600;
                    color: #666;
                    font-size: 0.85rem;
                }
                .sport-icon {
                    font-size: 1.6rem;
                }
                .cta-final {
                    text-align: center;
                    background: #f1f8e9;
                    padding: 40px 20px;
                    border-radius: 15px;
                }
                @media (max-width: 768px) {
                    .hero { padding: 40px 15px; margin-bottom: 30px; }
                    .hero h1 { font-size: 1.8rem; }
                    .hero p { font-size: 1rem; }
                    .hero-btns { flex-direction: column; width: 100%; max-width: 250px; margin: 0 auto; }
                    .sports-strip { gap: 15px; }
                    .section-title { font-size: 1.4rem; }
                    .cta-final { padding: 30px 15px; }
                }
                @media (max-width: 480px) {
                    .hero h1 {
                        font-size: 1.3 rem;
                    }
                    .sport-item {
                        font-size: 0.7rem;
                    }
                    .hero {
                        padding: 20px;
                        margin-bottom: 30px;
                    }
                    .hero-btns {
                        margin-top: 10px;
                    }
                }
            `}</style>

            <header className="hero">
                <h1>{t('hero_title').split(',')[0]},<br />{t('hero_title').split(',')[1]}</h1>
                <p>{t('hero_p')}</p>
                <div className="hero-btns">
                    <Link to="/register" className="hero-btn-primary">{t('start_free')}</Link>
                </div>
            </header>

            <h2 className="section-title">{t('one_tool_infinite_games')}</h2>
            <div className="sports-strip">
                {sports.map((s, i) => (
                    <div key={i} className="sport-item">
                        <span className="sport-icon">{s.icon}</span>
                        <span>{s.name}</span>
                    </div>
                ))}
            </div>

            <h2 className="section-title">{t('why_choose')}</h2>
            <div className="features-grid">
                {features.map((f, i) => (
                    <div key={i} className="feature-card">
                        <span className="feature-icon">{f.icon}</span>
                        <h3>{f.title}</h3>
                        <p>{f.description}</p>
                    </div>
                ))}
            </div>

            <section className="cta-final">
                <h2>{t('ready_to_play')}</h2>
                <p style={{ marginBottom: '30px', color: '#666' }}>{t('ready_to_play_p')}</p>
                <Link to="/register" className="hero-btn-secondary" >{t('create_first_league_now')}</Link>
            </section>
        </div>
    );
};

export default LandingPage;
